import { SettingsPanel } from "../components/SettingsPanel";

export function SettingsPage() {
  return (
    <div className="flex flex-col gap-4">
      <h1 className="text-xl font-bold tracking-tight">Settings</h1>
      <SettingsPanel />
    </div>
  );
}
